'use strict'

module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11463/lib/node_modules/landr/theme/node_modules/property-information/lib/util/case-sensitive-transform.js
// module id = 1357
// module chunks = 0